module.exports = __webpack_public_path__ + "static/media/998164.29eee885.jpg";